import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import LoginContainer from "./modules/auth/container/LoginContainer";
import AccessControl from "./modules/auth/component/AccessControl";
import ChatInterfaceContainer from "./modules/chat/container/ChatInterfaceContainer";
import TaskBoardContainer from "./modules/task/container/TaskBoardContainer";
import TaskNotifications from "./modules/chat/component/Notification";
import "./assets/css/layout/layout.scss";
import UserListContainer from "./modules/users/container/UserListContainer";
import SitesListContainer from "./modules/sites/container/UserListContainer";
import SiteGroupListContainer from "./modules/siteGroup/container/SiteGroupListContainer";
import PropConfigListContainer from "./modules/propConfig/container/PropConfigListContainer";
import PropContainerDetailContainer from "./modules/propConfig/container/PropConfigDetailContainer";
import TaskNotificationListContainer from "./modules/taskNotification/container/TaskNotificationListContainer";
import { useSelector } from "react-redux";
import Loader from "./components/Loader";

const AuthRequiredContainer = () => {

    const loading = useSelector((state) => state.ui.loading);  // Accessing loading state from Redux store
    
    return (
        <>
            {loading && <Loader />} {/* Show loader if loading is true */}
            <AccessControl>
                {/* <NotificationContainer> */}
                <Routes>
                    <Route path="/task" element={<TaskBoardContainer />} /> 
                    <Route path="/chat-interface" element={<ChatInterfaceContainer />} />
                    <Route path="/check" element={<TaskNotifications />} /> 
                    <Route path="/users" element={<UserListContainer />} /> 
                    <Route path="/sites" element={<SitesListContainer />} /> 
                    <Route path="/site-group" element={<SiteGroupListContainer />} /> 
                    <Route path="/prop-confg" element={<PropConfigListContainer />}/>
                    <Route path="/prop-confg/detail" element={<PropContainerDetailContainer />} />
                    <Route path="/task-notification" element={<TaskNotificationListContainer />} />
                </Routes>
                {/* </NotificationContainer> */}
                
            </AccessControl>
        </>
    )
}

const AppRoutes = () => (
    <BrowserRouter>
        <Routes>
            <Route path="/login" element={<LoginContainer />} />
            <Route element={<AuthRequiredContainer />} path='/ui/*' />
                 {/* Redirect root URL to /login */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            
            {/* Catch-all route to redirect to /login */}
            <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
    </BrowserRouter>
);


export default AppRoutes;
